import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@klarna/bubble-ui';
import { translator, Message } from 'mage-i18n';
import { Column, Row } from 'mage-components';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';

import SummaryColumn from '@/components/SummaryColumn';

import { CY_APPLICATION_OVERVIEW_PAGE_IDS } from './constants';

const tKey = 'products-fe.components.stakeholders.form';

const { POSTAL_CODE, ADDRESS_COUNTRY, REGION, STREET, CITY } = CY_APPLICATION_OVERVIEW_PAGE_IDS;

const SummaryAddress = ({ address, titleKey, t, ...rest }) => (
  <div {...rest}>
    <Row>
      <Column>
        <Typography textToken="text-style/headings/titles/bold/grande">
          <Message path={titleKey} />
        </Typography>
      </Column>
    </Row>
    <Row>
      <SummaryColumn
        content={address.postalCode}
        titleKey={`${tKey}.postal_code.label`}
        {...generateCyElemId(POSTAL_CODE, window)}
      />
      <SummaryColumn
        content={address.country}
        titleKey={`${tKey}.country.label`}
        {...generateCyElemId(ADDRESS_COUNTRY, window)}
      />
      {address.region && (
        <SummaryColumn
          content={
            address.country === 'US'
              ? t(`products-fe.options.us_states.${address.region}`, {}, address.region)
              : address.region
          }
          titleKey={`${tKey}.${address.country === 'US' ? 'state.label' : 'region.label_summary'}`}
          {...generateCyElemId(REGION, window)}
        />
      )}
      <SummaryColumn
        content={address.street}
        titleKey={`${tKey}.address.label`}
        {...generateCyElemId(STREET, window)}
      />
      <SummaryColumn
        content={address.city}
        titleKey={`${tKey}.city.label`}
        {...generateCyElemId(CITY, window)}
      />
    </Row>
  </div>
);

SummaryAddress.propTypes = {
  address: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  titleKey: PropTypes.string.isRequired,
};

export default connect(state => ({
  t: translator(state),
}))(SummaryAddress);
